import { BiMenu, BiPlus } from "react-icons/bi";
import { Link } from "react-router-dom";
import "./styles.scss";

import Logo from "assets/img/new-logo.png";
import SubLogo from "assets/img/sub-logo.svg";
import ImageRealizacao from "assets/img/bg-realizacao.png";
import ImageTop from "assets/img/bg-reconheca.png";
import ImageBottom from "assets/img/bg-footer.svg";
import FlorouIcon from "assets/img/florou.svg";
import PlantouIcon from "assets/img/plantou.svg";
import RaizIcon from "assets/img/raiz.svg";
import Lock from "assets/img/lock-icon.svg";
import Watch from "assets/img/relogio-icon.svg";
import IIcon from "assets/img/i-icon.svg";

export function Reconheca() {
  return (
    <div className="dashboard-static relative overflow-hidden">
      {/* Background image top right - behind cards */}
      <div
        className="absolute top-0 right-0 w-full h-[420px] bg-no-repeat bg-cover bg-right-top pointer-events-none"
        style={{ backgroundImage: `url(${ImageTop})`, zIndex: 0 }}
      />

      {/* Background image bottom left */}
      <div
        className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-no-repeat bg-contain bg-left-bottom pointer-events-none"
        style={{ backgroundImage: `url(${ImageBottom})`, zIndex: 1 }}
      />

      <div className="flex flex-col md:pt-10 pb-20 lg:pb-0 lg:flex-row mx-auto xl:container relative z-10">
        {/* Sidebar */}
        <div className="lg:w-1/3 flex flex-col items-center relative z-20 p-6 lg:p-3 md:mt-16">
          {/* Logo */}
          <div className="w-full flex flex-row lg:flex-col lg:items-center justify-between my-2 lg:my-0 relative">
            <div className="w-48 lg:w-72">
              <img src={Logo} alt="Reconheça" className="w-full" />
            </div>
            <div className="lg:hidden">
              <BiMenu size={32} />
            </div>
          </div>

          <div className="hidden lg:flex flex-col items-center w-full max-w-[280px] bg-[#031637] rounded-b-lg pt-20 py-6 px-4 mt-[-50px]">
            {/* Sub logo icon */}
            <div className="mb-4">
              <img src={SubLogo} alt="" className="w-16 h-16" />
            </div>

            <div className="text-center w-full mb-6">
              <h1 className="text-2xl lg:text-3xl text-white font-semibold leading-tight">
                FORÇA QUE <br />
                SUSTENTA <br />O FUTURO.
              </h1>
            </div>

            {/* Menu buttons */}
            <div className="flex flex-col space-y-4 w-full">
              <Link
                to="/destaques"
                className="bg-[#28ABE3] text-white py-2.5 w-full text-center uppercase rounded-md hover:bg-[#3BA0FF] hover:text-white hover:no-underline font-bold text-sm"
              >
                DESTAQUES
              </Link>

              <Link
                to="/pontos"
                className="bg-[#28ABE3] text-white py-2.5 w-full text-center uppercase rounded-md hover:bg-[#3BA0FF] hover:text-white hover:no-underline font-bold text-sm"
              >
                PONTOS
              </Link>

              <Link
                to="/regras"
                className="bg-[#28ABE3] text-white py-2.5 w-full text-center uppercase rounded-md hover:bg-[#3BA0FF] hover:text-white hover:no-underline font-bold text-sm"
              >
                REGRAS
              </Link>

              <Link
                to="/ajuda"
                className="bg-[#28ABE3] text-white py-2.5 w-full text-center uppercase rounded-md hover:bg-[#3BA0FF] hover:text-white hover:no-underline font-bold text-sm"
              >
                DÚVIDAS FREQUENTES
              </Link>

              <button className="bg-transparent border-2 border-[#28ABE3] text-white py-2.5 w-full text-center uppercase rounded-md hover:bg-[#28ABE3]/20 font-bold text-sm">
                SAIR
              </button>
            </div>
          </div>

          {/* Mobile: show sub logo and text without dark background */}
          <div className="lg:hidden">
            <div className="my-4">
              <img src={SubLogo} alt="" className="w-16 h-16" />
            </div>
            <div className="mt-4 text-left w-full">
              <h1 className="text-2xl text-white font-semibold leading-tight">
                FORÇA QUE <br />
                SUSTENTA <br />O FUTURO.
              </h1>
            </div>
          </div>
        </div>

        {/* Main content */}
        <div className="flex-1 p-6 lg:p-5 2xl:p-10 space-y-6 relative z-20">
          {/* User profile card */}
          <div className="relative border-[#28ABE3] border-2 bg-[#031637]  flex flex-col lg:flex-row overflow-hidden p-6 lg:p-8">
            {/* Column 1: Avatar + Seals */}
            <div className="flex flex-col items-center justify-between mr-10">
              {/* Avatar */}
              <div className="relative w-16 h-16 lg:w-20 lg:h-20 rounded-full bg-gray-400 overflow-hidden flex-shrink-0">
                <div className="w-full h-full bg-gradient-to-b from-orange-300 to-orange-500 flex items-center justify-center">
                  <span className="text-white text-2xl">F</span>
                </div>
              </div>

              {/* Seals - pushed to bottom */}
              <div className=" w-[70px] flex flex-col items-center mt-auto">
                <div className="bg-[#144077] rounded-[3px] p-2 w-full min-h-[70px] flex items-center justify-center">
                  <p className="text-center text-[9px] text-white leading-tight">
                    Você ainda não possui selos
                  </p>
                </div>
                <span className="text-grey-dark text-[10px] mt-4 uppercase underline hover:text-white cursor-pointer">
                  ver todos
                </span>
              </div>
            </div>

            {/* Column 2: Name, function, GRUPO DE PESSOAS, Level */}
            <div className="flex flex-col flex-1 mr-10">
              {/* Name and info */}
              <div className="flex items-center mb-1">
                <h3 className="text-white text-xl lg:text-2xl font-bold leading-none mr-2">
                  Fulano
                </h3>
                <span className="text-white/70 text-xs lg:text-sm leading-none">
                  (matrícula)
                </span>
              </div>

              <p className="text-sm font-light mb-[50px]">
                Função atual: <span className="text-[#28ABE3]">FUNÇÃO</span>
              </p>
              {/* <p className="text-sm font-light mb-3">
                Tipo de Acordo de Trabalho Conexão:{" "}
                <span className="text-[#28ABE3]">HÍBRIDO</span>
              </p> */}

              {/* GRUPO DE PESSOAS */}
              {/* <div className="flex flex-wrap items-center gap-2 text-sm mb-4">
                <span className="px-5 py-1.5 rounded-full bg-[#144077] text-white font-medium">
                  GRUPO DE PESSOAS
                </span>
                <span className="text-white/70">(102 funcis)</span>
                <img src={IIcon} alt="info" className="w-5 h-5" />
              </div> */}

              {/* Level section */}
              <div className="flex flex-col border-t-2 border-[#002B4B] pt-10">
                <div className="flex items-center gap-2 mb-2">
                  <p className="text-sm">
                    Nível: <b className="text-[#28ABE3]">Reconheça</b>
                  </p>
                  <img src={IIcon} alt="info" className="w-5 h-5" />
                </div>

                <div className="grid grid-cols-4 gap-3">
                  <div>
                    <p className="text-[10px] mb-1 text-[#28ABE3]">
                      #Reconheça
                    </p>
                    <div className="rounded-full h-[10px] bg-[#28ABE3]"></div>
                  </div>
                  <div>
                    <p className="text-[10px] mb-1 text-white">#Raiz</p>
                    <div className="rounded-full h-[10px] bg-transparent border border-[#C7D3EB]/30"></div>
                  </div>
                  <div>
                    <p className="text-[10px] mb-1 text-white">#Plantou</p>
                    <div className="rounded-full h-[10px] bg-transparent border border-[#C7D3EB]/30"></div>
                  </div>
                  <div>
                    <p className="text-[10px] mb-1 text-white">#Floriu</p>
                    <div className="rounded-full h-[10px] bg-transparent border border-[#C7D3EB]/30"></div>
                  </div>
                </div>
              </div>
            </div>

            {/* Column 3: Points */}
            <div className="flex flex-col  items-center justify-between pl-6 space-y-3 min-w-[160px]">
              <div className="text-center w-full">
                <p className="text-white text-xs mb-1">
                  Pontos <br /> Reconhecer:
                </p>
                <div className="mb-4 bg-white text-center text-[#28ABE3] rounded-full py-2 px-4 text-xl font-bold">
                  2.600
                </div>

                <p className="text-white text-xs mb-1">
                  Pontos <br />
                  Realizações Destaque:
                </p>
                <div className="bg-white text-center text-[#28ABE3] rounded-full py-2 px-4 text-xl font-bold">
                  2.600
                </div>
              </div>

              <button className="mt-auto text-grey-dark text-xs uppercase flex items-center gap-1 hover:text-white">
                <BiPlus size={14} />
                VER EXTRATO
              </button>
            </div>
          </div>

          {/* Recognize colleagues card */}
          <div className="relative border-2 border-[#28ABE3] bg-[#031637]  px-6 lg:px-8 py-8">
            <h2 className="text-white font-semibold text-xl lg:text-2xl mb-6">
              Reconheça seus colegas
            </h2>

            <div className="lg:flex lg:gap-8">
              <div className="lg:w-2/3 mb-8 lg:mb-0">
                <h3 className="text-white font-normal text-base mb-5">
                  Saldo total para enviar reconhecimentos:{" "}
                  <span className="text-[#28ABE3] font-bold">1.000 pontos</span>
                </h3>

                <div className="flex flex-wrap gap-4 justify-center lg:justify-start mb-6">
                  {/* FLORIU */}
                  <div className="bg-[#144077] p-4 px-6 flex flex-col items-center min-w-[120px]">
                    <div className="flex items-center gap-2 mb-3">
                      <img src={FlorouIcon} alt="Floriu" className="w-8 h-8" />
                      <p className="font-medium text-xs text-white">#FLORIU</p>
                    </div>
                    <p className="text-[#28ABE3] text-xs bg-[#002B4B] py-1 px-3 rounded-full">
                      300 pontos
                    </p>
                  </div>

                  {/* PLANTOU */}
                  <div className="bg-[#144077] p-4 px-6 flex flex-col items-center min-w-[120px]">
                    <div className="flex items-center gap-2 mb-3">
                      <img
                        src={PlantouIcon}
                        alt="Plantou"
                        className="w-8 h-8"
                      />
                      <p className="font-medium text-xs text-white">#PLANTOU</p>
                    </div>
                    <p className="text-[#28ABE3] text-xs bg-[#002B4B] py-1 px-3 rounded-full">
                      200 pontos
                    </p>
                  </div>

                  {/* RAIZ */}
                  <div className="bg-[#144077] p-4 px-6 flex flex-col items-center min-w-[120px]">
                    <div className="flex items-center gap-2 mb-3">
                      <img src={RaizIcon} alt="Raiz" className="w-8 h-8" />
                      <p className="font-medium text-xs text-white">#RAIZ</p>
                    </div>
                    <p className="text-[#28ABE3] text-xs bg-[#002B4B] py-1 px-3 rounded-full">
                      100 pontos
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-2 text-sm text-white mb-3">
                  <span>Seu saldo atual expira em:</span>
                  <span className="flex items-center gap-1 text-[#D77098] font-bold">
                    <img src={Watch} alt="timer" className="w-5 h-5" />2 dias,
                    06:50:00
                  </span>
                </div>

                <div className="flex items-center gap-2 text-xs text-gray-400">
                  <span>Início</span>
                  <div className="flex-1 bg-transparent border border-[#C7D3EB]/30 rounded-full h-[10px]">
                    <div
                      className="bg-[#D77098] h-[10px] rounded-full"
                      style={{ width: "70%" }}
                    ></div>
                  </div>
                  <span>Até 00/00/0000</span>
                </div>
              </div>

              <div className="flex-1 flex flex-col text-center items-center justify-center">
                <p className="text-sm font-light text-white mb-4 leading-relaxed">
                  Viu alguém que fez a diferença
                  <br />
                  no seu trabalho?
                  <br />
                  Deixe-o ficar sabendo disso!
                </p>
                <button className="bg-[#28ABE3] text-white uppercase py-3 px-6 rounded-md font-bold text-sm mb-4">
                  RECONHECER COLEGA
                </button>

                <button className="text-grey-dark text-xs uppercase flex items-center gap-1 hover:text-white">
                  <BiPlus size={14} />
                  VER RECONHECIMENTOS
                </button>
              </div>
            </div>
          </div>

          {/* Realizacoes Destaque card */}
          <div className="relative border-2 border-[#28ABE3] bg-[#031637]  px-6 lg:px-8 py-8 overflow-hidden">
            {/* Top section with text and image */}
            <div className="lg:flex lg:gap-8 mb-6">
              <div className="lg:w-2/3 mb-8 lg:mb-0 relative z-10">
                <h2 className="text-white font-semibold text-xl lg:text-2xl mb-4">
                  Realizações Destaque
                </h2>

                <p className="text-sm font-light text-white mb-6">
                  Visualize suas Realizações Destaque e acompanhe os status de
                  apreciação.
                </p>

                <h3 className="text-[#28ABE3] font-normal text-sm mb-2 cursor-pointer">
                  Que tal cadastrar uma Realização Destaque nesta fase?
                </h3>

                <p className="text-sm font-light text-white mb-4">
                  Cadastre sua Realização Destaque, seja reconhecido pela sua
                  liderança e ganhe recompensas! <strong>Lembre-se:</strong>{" "}
                  você só pode cadastrar uma realização por fase e ela deve
                  estar <strong>concluída</strong>.
                </p>

                <div className="flex items-center text-sm text-white mb-4">
                  <span>A fase será finalizada em:</span>
                  <span className="ml-2 text-[#D77098] font-bold flex items-center gap-1">
                    <img src={Watch} alt="timer" className="w-5 h-5" />
                    24:00:00
                  </span>
                </div>

                <div className="flex items-center gap-2 text-xs text-gray-400">
                  <span>De 01/06/2025</span>
                  <div className="flex-1 bg-transparent border border-[#C7D3EB]/30 rounded-full h-[10px]">
                    <div
                      className="bg-[#D77098] h-[10px] rounded-full"
                      style={{ width: "85%" }}
                    ></div>
                  </div>
                  <span>Até 08/06/2025</span>
                </div>
              </div>

              {/* Decorative image - limited to text section height */}
              <div className="hidden lg:flex flex-1 items-start justify-center relative z-10">
                <img
                  src={ImageRealizacao}
                  alt=""
                  className="w-full max-w-[200px] max-h-[290px] rounded-md object-cover"
                />
              </div>
            </div>

            {/* Agenda de Apreciacao - full width below */}
            <div className="bg-[#144077]  p-4 mb-6">
              <h4 className="text-white font-bold text-sm mb-4">
                Agenda de Apreciação
              </h4>

              {/* Header row with Validação and Níveis */}
              <div className="grid grid-cols-4 gap-2 mb-2">
                <div className="flex items-center gap-2">
                  <span className="text-white text-sm">Validação</span>
                </div>
                <div className="flex items-center gap-1">
                  <img src={Lock} alt="lock" className="w-5 h-5" />
                  <span className="text-[#597B95] text-xs">Nível 1</span>
                </div>
                <div className="flex items-center gap-1">
                  <img src={Lock} alt="lock" className="w-5 h-5" />
                  <span className="text-[#597B95] text-xs">Nível 2</span>
                </div>
                <div className="flex items-center gap-1">
                  <img src={Lock} alt="lock" className="w-5 h-5" />
                  <span className="text-[#597B95] text-xs">Nível 3</span>
                </div>
              </div>

              {/* Progress bars */}
              <div className="grid grid-cols-4 gap-2 mb-2">
                <div className="h-[10px] bg-[#C7D3EB] rounded-full"></div>
                <div className="h-[10px] bg-[#C7D3EB] rounded-full"></div>
                <div className="h-[10px] bg-[#C7D3EB] rounded-full"></div>
                <div className="h-[10px] bg-[#C7D3EB] rounded-full"></div>
              </div>

              {/* Dates */}
              <div className="grid grid-cols-4 gap-2 text-xs text-[#D77098]">
                <span>De 01/05 a 08/05</span>
                <span>De 09/05 a 16/05</span>
                <span>De 17/05 a 24/05</span>
                <span>De 29/07 a 05/08</span>
              </div>
            </div>

            {/* Buttons - centered */}
            <div className="flex flex-wrap gap-4 justify-center">
              <button className="bg-[#28ABE3] text-white uppercase py-3 px-6 rounded-[4px] font-bold text-sm">
                CADASTRAR REALIZAÇÃO
              </button>
              <button className="bg-transparent border-2 border-[#28ABE3] text-white uppercase py-3 px-6 rounded-[4px] font-bold text-sm">
                ACOMPANHAR REALIZAÇÕES
              </button>
            </div>
          </div>

          {/* Acoes de Engajamento card */}
          <div className="relative border-2 border-[#28ABE3] bg-[#031637]  px-6 lg:px-8 py-8">
            <h2 className="text-white font-semibold text-xl lg:text-2xl mb-2">
              Ações de Engajamento
            </h2>

            <p className="text-sm font-light text-white mb-1">
              Acompanhe aqui atividades extras disponíveis durante este ciclo,
              que podem gerar pontuação bônus para você.
            </p>

            <p className="text-[#D77098] text-sm font-bold mb-4">
              Ciclo 1S2025
            </p>

            <div className="flex flex-col lg:flex-row items-center justify-between gap-4">
              <div className="bg-[#144077]  p-4 w-[70%]">
                <h4 className="text-[#28ABE3] font-bold text-sm mb-1">
                  Desafio semestral 1S2025
                </h4>
                <p className="text-white text-sm">
                  Você realizou 5/7 desafios disponíveis.
                </p>
                <p className="text-white text-sm">
                  Prazo para cumprimento: 10 de março a 30 de junho de 2025
                </p>
              </div>
              <button className="bg-[#28ABE3] text-white uppercase py-3 px-5 rounded-md font-bold text-sm whitespace-nowrap">
                ACESSAR DESAFIOS
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reconheca;
